import { useState, useEffect } from 'react';
import api from '../helpers/api';

/**
 * Hook that fetches and caches downtime reasons from the API.
 * Replaces the duplicated useState + useEffect pattern across 10+ files.
 *
 * @returns {{ downtimeReasons: Array, loadingReasons: boolean }}
 */
export function useDowntimeReasons() {
  const [downtimeReasons, setDowntimeReasons] = useState([]);
  const [loadingReasons, setLoadingReasons] = useState(false);

  useEffect(() => {
    setLoadingReasons(true);
    api.get('asset/downtime-reason')
      .then(res => setDowntimeReasons(res.data?.response || []))
      .catch(() => setDowntimeReasons([]))
      .finally(() => setLoadingReasons(false));
  }, []);

  return { downtimeReasons, loadingReasons };
}
